export default "/50f517735fec46580f19aae3e56e9fe21614ea75/569373b84d4fa61cda98164451d2ed57.svg";